<template>
	<div>
		<Header />

		<Hero />

		<CategoryCards />

		<Subscribe />
	</div>
</template>

<script>
import Header from '@/components/Header';
import Hero from '@/components/Hero';
import CategoryCards from '@/components/CategoryCards';
import Subscribe from '@/components/Subscribe';

export default {
	name: 'Landing',
	components: { Header, Hero, CategoryCards, Subscribe },
	data: () => ({
		role: '',
		location: '',
	}),
	methods: {
		searchButton() {
			this.$router.push({
				path: "/search",
				query: { q: this.keyword, l: this.location },
			});
		},
	},
};
</script>
